import React, { type FC } from 'react';

import clsx from 'clsx';
import ReactMarkdown, { type Options } from 'react-markdown';
import remarkGfm from 'remark-gfm';

import Box from '../box/box';

export type MarkdownParserProps = Options & {
  /** Allows the component to get additional styles. */
  className?: string;
};

const MarkdownParser: FC<MarkdownParserProps> = ({ children, components, className, ...rest }) => (
  <Box
    css={theme => [
      theme.shared.htmlParserStyles,
      {
        '& > .codeInline': {
          display: 'inline',
          padding: `0 ${theme.space.s8}px`,
          border: 'none',
        },
      },
    ]}
  >
    <ReactMarkdown
      {...rest}
      components={{
        ...components,
        // eslint-disable-next-line unused-imports/no-unused-vars, @typescript-eslint/no-unused-vars
        code: ({ node, className: componentClassName, ...rest }) => (
          <Box className={clsx('codeInline', className, componentClassName)}>
            <code {...rest} />
          </Box>
        ),
        // eslint-disable-next-line unused-imports/no-unused-vars, @typescript-eslint/no-unused-vars
        table: ({ node, className: componentClassName, ...rest }) => (
          <Box className={clsx('alternating', className, componentClassName)}>
            <table {...rest} />
          </Box>
        ),
      }}
      remarkPlugins={[remarkGfm]}
    >
      {/* two spaces before a new line character seems to give markdown what it wants */}
      {children?.replace(/\n/gi, '  \n')}
    </ReactMarkdown>
  </Box>
);

export { MarkdownParser };
export default MarkdownParser;
